// extracted by mini-css-extract-plugin
module.exports = {"cinemasPart":"cinemasPart___vP4mk","regions":"regions___1wo6Y","region":"region___Y41YQ","item":"item___qTtsX","title":"title___3SVgG","address":"address___25lUw"};